import { render, staticRenderFns } from "./_SpecFeatueFormModal.vue?vue&type=template&id=08fd718d&"
import script from "./_SpecFeatueFormModal.vue?vue&type=script&lang=js&"
export * from "./_SpecFeatueFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports